/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

// Log app initialization - CRITICAL: These logs must appear in production
// Using multiple methods to ensure logs are visible
const initInfo = {
  timestamp: new Date().toISOString(),
  userAgent: navigator.userAgent,
  url: window.location.href,
  hasIndexedDB: 'indexedDB' in window,
  hasLocalStorage: 'localStorage' in window
};

// Method 1: console.log (should work with drop: [])
console.log('[App] ============================================');
console.log('[App] Application initializing...', initInfo);
console.log('[App] ============================================');

// Method 2: window property (always visible, cannot be stripped)
(window as any).__VERITAS_APP_INIT__ = initInfo;

// Method 3: DOM element (visible in inspector)
if (typeof document !== 'undefined') {
  const meta = document.createElement('meta');
  meta.name = 'veritas-app-init';
  meta.content = JSON.stringify(initInfo);
  document.head.appendChild(meta);
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for PWA features and update detection
if (import.meta.env.PROD) {
  import('./lib/sw-registration').then(({ registerServiceWorker }) => {
    console.log('[App] Registering Service Worker...');
    registerServiceWorker();
  }).catch(err => {
    console.error('[App] Failed to register Service Worker:', err);
  });
}
